import script from "./CarViver.vue?vue&type=script&setup=true&lang=js"
export * from "./CarViver.vue?vue&type=script&setup=true&lang=js"

import "./CarViver.vue?vue&type=style&index=0&id=9c3c1be4&lang=css"

const __exports__ = script;

export default __exports__